/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Form from 'bundles/authentication-common/components/Form';
import Separator from 'bundles/authentication-common/components/Separator';
import Submit from 'bundles/authentication-common/components/Submit';
import EmailInput from 'bundles/authentication-common/components/inputs/EmailInput';
import { EMAIL_CONSTRAINT } from 'bundles/authentication-common/constants/constraints';
import { isVisualImprovementsToAuthModalsEnabled } from 'bundles/authentication/utils/experimentUtils';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/authentication';

type Props = {
  onSubmit: (values: { email: string }) => void;
  onRequestMagicLink: () => void;
  submitCTALabel?: string;
  submitCTATrackingName?: string;
};

const TrackedSubmit = withSingleTracked({ type: 'BUTTON' })(Submit);

const getStyles = (enableVisualImprovements: boolean) => ({
  form: css`
    display: grid;
    grid-gap: ${enableVisualImprovements ? 'var(--cds-spacing-200)' : 'var(--cds-spacing-150)'};
    grid-template-columns: 1fr;
  `,
  submit: css`
    margin-top: ${enableVisualImprovements ? '0px' : 'var(--cds-spacing-150)'};
  `,
  separator: css`
    margin: 4px 0;
  `,
});

const ForgotPasswordForm = ({
  onSubmit,
  onRequestMagicLink,
  submitCTALabel = _t('Reset Password'),
  submitCTATrackingName = 'reset_page_button',
}: Props) => {
  const isVisualImprovementsEnabled = isVisualImprovementsToAuthModalsEnabled();
  const styles = getStyles(isVisualImprovementsEnabled);

  return (
    <Form
      css={styles.form}
      constraints={{ email: EMAIL_CONSTRAINT }}
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      onSubmit={(values) => onSubmit({ email: values?.email })}
    >
      <EmailInput />
      <TrackedSubmit css={styles.submit} trackingName={submitCTATrackingName}>
        {submitCTALabel}
      </TrackedSubmit>
      <>
        <Separator
          css={styles.separator}
          text={_t('or')}
          customStyles={{ margin: isVisualImprovementsEnabled ? '6px 0' : '24px 0' }}
        />
        <TrackedSubmit
          css={styles.submit}
          trackingName="send_login_link_button"
          onClick={onRequestMagicLink}
          secondary={true}
        >
          {_t('Email me a login link')}
        </TrackedSubmit>
      </>
    </Form>
  );
};

export default ForgotPasswordForm;
